import React from "react";
import moment from "moment";
import Cookies from "js-cookie";
import { useSelector } from "react-redux";
export function FormatDateTime({ text, format }) {
  const dateFormat = (f) => {
    switch (f) {
      case "dmy":
        return "D/M/YYYY";
      case "Hm":
        return "HH:mm";
      case "dmyHm":
        return "D/M/YYYY HH:mm";
      default:
        return "D/M/YYYY HH:mm:ss";
    }
  };

  if (!text) {
    return "-";
  }

  return <>{moment(text).format(dateFormat(format))}</>;
}

export function FromNow({ text }) {
  return <>{moment(text).fromNow()}</>;
}

export function TotalTime({
  title,
  wrapClassName,
  mode = "full",
  days,
  hour,
  min,
}) {
  const locale = Cookies.get("locale");
  const factupdate = useSelector((state) => state.masterLang.factUpdate);
  const language = useSelector((state) => state.masterLang.masterLang);
  const labelTime = {
    day: {
      full: ` ${factupdate ? language[locale]["days"] : "Days "} `,
      short: "D",
    },
    hours: {
      full: ` ${factupdate ? language[locale]["hours"] : "Hours "} `,
      short: "H",
    },
    minutes: {
      full: ` ${factupdate ? language[locale]["minutes"] : "Minutes "} `,
      short: "M",
    },
  };
  if (Number(days) === 0 && Number(hour) === 0 && Number(min) === 0) {
    return (
      <span>
        {title}0 {factupdate ? language[locale]["minutes"] : `Minutes`}
      </span>
    );
  } else {
    const res = () => {
      let tempData = "";
      if (days && days > 0) {
        tempData += `${days}${labelTime.day[mode]}`;
      }
      if (hour && hour > 0) {
        tempData += `${hour}${labelTime.hours[mode]}`;
      }
      if (min && min > 0) {
        tempData += `${min}${labelTime.minutes[mode]}`;
      }
      return tempData.trim();
    };

    return <span className={wrapClassName}>{res()}</span>;
  }
}

export function NumberWithCommas({ number }) {
  const formatNumber = () => {
    let parts = number.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
  };
  return <>{formatNumber()}</>;
}
